export default {
	name: 'orderQuery',
	data() {
		return {
			search: '',
			clear: {},
			pageIndex: 1,
			pageRows: 5,
			count: 0,
			beginData: '',
			endTime: '',
			getData: {},
			orders: [],
			ShopID: this.$store.state.user.ShopID,
			areaID: this.$store.state.user.areaID,
			Shop: this.$store.state.shop.filter(x => x.areaID == this.areaID)

		}
	},
	created() {
		this.areaID = this.$store.state.user.areaID;
		this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
		
		this.getData = () => {

			this.$request.request({
				url: 'Query/queryOrder',
				data: {
					pageIndex: this.pageIndex,
					pageCount: this.pageRows,
					beginData: this.beginData,
					endTime: this.endTime,
					searchText: this.search,
					ShopID: this.ShopID
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.search = r.searchText,
						this.orders = r.orders;
					this.count = r.count;
				} else {
					this.$uil.showMessage({
						text: r.message
					});
				}
			})
		}
		this.getData();

	},
	methods: {
		selectArea() {
			this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
			this.count = 0;
			if (this.Shop.length > 0) {
				this.ShopID = this.Shop[0].ShopID;
				this.pageIndex = 1;
				this.getData();
			}
		},
		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;

			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}
			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		},
		orderstate(v, s) {
			switch (v) {
				case 0:
					return '待付款';
				case 1:
					return '待配书';
				case 2:
					return s == 3 ? '取回中' : '配送中';
				case 4:
					return '借阅中';
				case 5:
					return '还书';
				case 6:
					return '已还书';
				case 7:
					return '已取消';
				case 8:
					return '已售出';
			}
		},
		orderstype(v) {
			switch (v) {
				case 1:
					return '线下借书单';
				case 2:
					return '微信借书单';
				case 3:
					return '微信还书单';
				case 4:
					return '线下售书单';
			}
		}
	},
	computed: {
		checkbook() {
			return this.BooksName.length > 0 && this.BookBriefIntroduction.length > 0 && this.WriterName.length > 0 &&
				this.ClassificationID >
				0 && this.RecommendReason.length > 0 && this.BookRecommend.length > 0 && this.Tag.length > 0;
		},
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		}
	},
	filters: {

	},
	activated() {
		this.getData();
	}

}
